import React, {useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Switch, Route, useHistory, useLocation } from 'react-router-dom';
import './index.css';
import './markdown.extend.less';
import * as serviceWorker from './serviceWorker';
import Lesson from './pages/lesson';
import BaseLayout from "./layout/base";
import configStore from './store';
import {Provider, useDispatch} from 'react-redux';
import Playground from "./pages/playground";
import Home from "./pages/home";
import Login from "./pages/login";
import UserCenter from "./pages/user-center";
import axios from 'axios';
import constant from "./store/constant";
import {Spinner} from "@blueprintjs/core";
import dayjs from "dayjs";
import updateLocal from 'dayjs/plugin/updateLocale';
import PermissionDenied from "./pages/permission-denied";
import NotFound from "./pages/not-found";
import ExchangeCourse from "./pages/exchange-course";
import Example from "./pages/example";
import PartFinished from "./pages/part-finished";
import Share from "./pages/share";
import isToday from 'dayjs/plugin/isToday';
import Sales from "./pages/sales";
import AccountLogin from "./pages/account-login";

serviceWorker.unregister();
dayjs.extend(isToday);
dayjs.extend(updateLocal);
dayjs.updateLocale('en', {
  weeks: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
});

axios.defaults.withCredentials = true;
if (/py2fun\.com/.test(window.location.href)) {
  axios.defaults.baseURL = 'http://api.py2fun.com/';
} else {
  axios.defaults.baseURL = 'http://api.pythontip.com/';
}

// 此处处理request
axios.interceptors.request.use((config) => config);

// 此处处理response
axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (!error.response) {
    return Promise.resolve({
      data: {
        code: 4,
        msg: '网络错误'
      }
    })
  }
  if (error.response.status === 400) {
    return Promise.resolve({
      data: {
        code: 2,
        msg: '用户名或密码错误'
      }
    });
  }
  if (error.response.status === 401) {
    return Promise.resolve({
      data: {
        code: 3,
        msg: '用户权限错误'
      }
    });
  }
});

const store = configStore();

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <Entry />
      </Router>
    </Provider>
  );
};

const Entry = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (verified === true) {
      return;
    }
    if (location.pathname === '/login' || location.pathname === '/account-login') {
      setLoading(false);
      return;
    }
    if (/\/(share|sales)\/[a-zA-z0-9]+/.test(location.pathname)) {
      setLoading(false);
      return;
    }
    axios.get('/api/pytip/wechat_is_login').then((response) => {
      const { code, data } = response.data;
      if (code === 0) {
        if (data.is_login === false) {
          history.replace('/login');
          return;
        }
        const isWxBind = data.is_wx_bind;
        axios.get('/api/course/student_profile').then(response => {
          setLoading(false);
          const { data } = response.data;
          const { user_info: userInfo = {} } = data;
          if (userInfo.user_id === null) {
            history.replace('/login');
            return;
          }
          dispatch({
            type: constant.userInfo.SET_USER_INFO,
            payload: {
              avatar: userInfo.avatar,
              userId: userInfo.user_id,
              userName: userInfo.user_name,
              isWxBind: isWxBind
            }
          });
          setVerified(true);
          // 如果没有兑换课程，跳转到兑换课程页面
          if (!data.has_course) {
            history.replace('/exchange-course');
          }
        });
      }
    });

  }, [dispatch, history, location.pathname, verified]);

  const renderRouters = () => {
    return (
      <Switch>
        <Route path='/' exact component={Home}/>
        <Route path='/learn/:chapterName/:chapterId/:lessonId' component={Lesson}/>
        <Route path='/playground' component={Playground}/>
        <Route path='/login' component={Login}/>
        <Route path='/account-login' component={AccountLogin}/>
        <Route path='/user-center' component={UserCenter}/>
        <Route path='/permission-denied' component={PermissionDenied}/>
        <Route path='/exchange-course' component={ExchangeCourse}/>
        <Route path='/example' component={Example}/>
        <Route path='/part-finished' component={PartFinished} />
        <Route path='/share/:shareKey' component={Share} />
        <Route path='/sales' component={Sales} />
        <Route path='*' component={NotFound}/>
      </Switch>
    );
  };

  const renderLoading = () => {
    return (
      <div className='loading'>
        <Spinner />
      </div>
    );
  };

  return (
    <BaseLayout>
      {loading ? renderLoading() : renderRouters()}
    </BaseLayout>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));

